import { STORAGE_KEYS } from "../constants/storageKeys";

export const verifyHostName = (envHostName: string) => {
  return window.location.hostname === envHostName;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  cookies.forEach((cookie) => {
    document.cookie =
      cookie.split("=")[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
  });
};

export const getLocalStorageItem = (key: string) => localStorage.getItem(key);

export const setLocalStorageItem = (key: string, value: string) =>
  localStorage.setItem(key, value);

export const deleteLocalStorageItem = (key: string) =>
  localStorage.removeItem(key);

export const getSessionStorageItem = (key: string) =>
  sessionStorage.getItem(key);

export const setSessionStorageItem = (key: string, value: string) =>
  sessionStorage.setItem(key, value);

export interface IUserContextInfo {
  corporateEntityId: number;
  practiceId: number;
  siteId: number;
  siteSpecialtyTypeId: number;
  stationId: number;
}

export const getLocalStorageUserContextInfo = (): IUserContextInfo | null => {
  const loggedInUserIdString = getLocalStorageItem(STORAGE_KEYS.UserLoginId);
  if (!loggedInUserIdString) {
    return null;
  }

  const userContextInfo = getLocalStorageItem(loggedInUserIdString);
  return userContextInfo
    ? (JSON.parse(userContextInfo) as IUserContextInfo)
    : null;
};

export const setLocalStorageUserContextInfo = (
  userContextInfo: IUserContextInfo,
) => {
  setLocalStorageItem(
    getLocalStorageItem(STORAGE_KEYS.UserLoginId) as string,
    JSON.stringify(userContextInfo),
  );
};

export const getNameForDisplay = (detail?: {
  displayName: string | null;
  name: string;
}) => {
  return detail?.displayName ?? detail?.name ?? "";
};

export const generateUserContextCustomHeader = ():
  | {
      isUserPracticeInfoTruthy: false;
    }
  | {
      isUserPracticeInfoTruthy: true;
      userContextCustomHeader: string;
    } => {
  const userContextInfo: IUserContextInfo | null =
    getLocalStorageUserContextInfo();
  if (!userContextInfo) {
    return {
      isUserPracticeInfoTruthy: false,
    };
  }

  return {
    isUserPracticeInfoTruthy: true,
    userContextCustomHeader: [
      userContextInfo.corporateEntityId,
      userContextInfo.practiceId,
      userContextInfo.siteId,
      userContextInfo.siteSpecialtyTypeId,
      userContextInfo.stationId,
    ].join("-"),
  };
};
